import React, { useState, useEffect, createContext, useContext } from 'react';
import WPApiFetch from '../Utility/WPApi'
import { getBaseURL } from '../Utility/getBaseURL'

export const NavigationContext = createContext();

function normalizeURLsIterator(menu_item_array) {
	menu_item_array.forEach(function(item,inx) {
		menu_item_array[inx].url = normalizeURL(item.url);
		if(item.children) {
			menu_item_array[inx].children = normalizeURLsIterator(item.children);
		}
	});
	return menu_item_array;
}
function normalizeURLs(menus_object) {
	for (var property in menus_object) {
		if(menus_object[property] && menus_object[property].menu) {
			menus_object[property].menu.items = normalizeURLsIterator(menus_object[property].menu.items);
		}
	}
	return menus_object;
}
function normalizeURL(url) {
	const baseURL = getBaseURL();
	if(url.includes(baseURL)) { return url; }
	url = baseURL + '/' + url;
	url = url.replace( baseURL + '//', baseURL + '/' )
	url = url.replace( baseURL + '/#', '#' )
	if(url.includes(global.config.devURL) || url.includes(global.config.buildURL)) {
		url = url.replace(baseURL + '/', '');
		url = url.replace(global.config.devURL, '');
		url = url.replace(global.config.buildURL, '');
	}
	if(url.length === 0) { url = '/'; }
	return url;
}

export default function NavigationProvider({children}) {
	const [navigation, setNavigation] = useState(global.navigationPlaceholder);
	useEffect(() => {
	    async function fetchNavigation() {
		   	const route = '/r-flix/v1/menu-data'
			const data = await WPApiFetch(route)
			setNavigation( normalizeURLs( data )  );
	    }
	    fetchNavigation();
	}, [])
	return <NavigationContext.Provider value={navigation}>{children}</NavigationContext.Provider>
}

export function useNavigation() {
	const context = useContext(NavigationContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}